import baseAPI from "@/http";

const router = "api/municipio-proposta";

export const propostaApi = {
  remove: (propostaId) => baseAPI.delete(`${router}?id=${propostaId}`),
  list: () => baseAPI.get(`${router}`),
  find: (propostaId) => baseAPI.get(`${router}/${propostaId}`),
  update: (proposta) => baseAPI.put(`${router}`, proposta),
  gerarProposta: (proposta) =>
    baseAPI.post(`${router}/gerar-proposta`, proposta, {
      responseType: "blob",
    }),
  getPropostasPorMunicipioId: (municipioId) =>
    baseAPI.get(`${router}/obter-proposta-por-municipio/${municipioId}`),
  getProximoNumeroProposta: () =>
    baseAPI.get(`${router}/obter-proximo-numero-proposta`),

  downloadProposta: (propostaId) =>
    baseAPI.post(
      `${router}/download-proposta?municpioPropostaId=${propostaId}`,
      null,
      {
        responseType: "blob",
      }
    ),
  downloadMinuta: (propostaId) =>
    baseAPI.post(
      `${router}/download-minuta?municpioPropostaId=${propostaId}`,
      null,
      {
        responseType: "blob",
      }
    ),
  enviarAnexo: (proposta) => baseAPI.post(`${router}/enviar-anexo`, proposta),
  downloadMinutaAssinada: (propostaId) =>
    baseAPI.post(
      `${router}/download-minuta-assinada?municpioPropostaId=${propostaId}`,
      null,
      {
        responseType: "blob",
      }
    ),
};

const routerDados = "api/municipio-proposta-dados";

export const municipioPropostaDadosApi = {
  remove: (dadosId) => baseAPI.delete(`${routerDados}?id=${dadosId}`),
  list: () => baseAPI.get(`${routerDados}`),
  find: (dadosId) => baseAPI.get(`${routerDados}/${dadosId}`),
  update: (dados) => baseAPI.put(`${routerDados}`, dados),
  add: (dados) => baseAPI.post(`${routerDados}`, dados),
  getDadosPorMunicipioId: (municipioId) =>
    baseAPI.get(
      `${routerDados}/obter-dados-complementares-por-municipioId/?municipioId=${municipioId}`
    ),
};

const routerCombo = "api/municipios-propostas-combos";

export const municipioPropostaComboApi = {
  remove: (dadosId) => baseAPI.delete(`${routerCombo}?id=${dadosId}`),
  list: () => baseAPI.get(`${routerCombo}`),
  find: (dadosId) => baseAPI.get(`${routerCombo}/${dadosId}`),
  update: (dados) => baseAPI.put(`${routerCombo}`, dados),
  add: (dados) => baseAPI.post(`${routerCombo}`, dados),
  getDadosPorMunicipioId: (municipioId) =>
    baseAPI.get(
      `${routerCombo}/obter-combo-por-id/?municipioId=${municipioId}`
    ),
};

const routeranexo = "api/municipio-proposta-anexo";
export const municipioPropostaAnexoAPI = {
  remove: (municipioPropostaAnexosId) =>
    baseAPI.delete(`${routeranexo}?id=${municipioPropostaAnexosId}`),
  downloadAnexo: (municipioPropostaAnexosId) =>
    baseAPI.post(
      `${routeranexo}/download-anexo?municipioPropostaAnexosId=${municipioPropostaAnexosId}`,
      null,
      {
        responseType: "blob",
      }
    ),
};

const routerParcelaAnexo = "api/MunicipioPropostaParcelasAnexos";
export const municipioPropostaParcelasAnexoAPI = {
  remove: (municipioPropostaParcelasAnexosId) =>
    baseAPI.delete(
      `${routerParcelaAnexo}?id=${municipioPropostaParcelasAnexosId}`
    ),
  salvarAnexo: (dados) => baseAPI.post(`${routerParcelaAnexo}`, dados),
  downloadAnexo: (municipioPropostaParcelaAnexosId) =>
    baseAPI.post(
      `${routerParcelaAnexo}/download-parcelas-anexos?id=${municipioPropostaParcelaAnexosId}`,
      null,
      {
        responseType: "blob",
      }
    ),
};

const routerParcelas = "api/municipio-proposta-parcelas";
export const municipioPropostaParcelasApi = {
  remove: (dadosId) => baseAPI.delete(`${routerParcelas}?id=${dadosId}`),
  list: () => baseAPI.get(`${routerParcelas}`),
  find: (dadosId) => baseAPI.get(`${routerParcelas}/${dadosId}`),
  update: (dados) => baseAPI.put(`${routerParcelas}`, dados),
  add: (dados) => baseAPI.post(`${routerParcelas}`, dados),
  getPorPropostasId: (propostaId) =>
    baseAPI.get(
      `${routerParcelas}/obter-parcelas-por-proposta-id?id=${propostaId}`
    ),
};

const routerPropostaGrupoSolucao = "api/municipio-proposta-grupo-solucao";
export const municipioPropostaGrupoSolucaApi = {
  remove: (dadosId) =>
    baseAPI.delete(`${routerPropostaGrupoSolucao}?id=${dadosId}`),
  list: () => baseAPI.get(`${routerPropostaGrupoSolucao}`),
  find: (dadosId) => baseAPI.get(`${routerPropostaGrupoSolucao}/${dadosId}`),
  update: (dados) => baseAPI.put(`${routerPropostaGrupoSolucao}`, dados),
  add: (dados) => baseAPI.post(`${routerPropostaGrupoSolucao}`, dados),
};

const routerSolucaoExtra = "api/municipio-proposta-solucoes-extras";
export const municipioPropostaSolucaoExtraApi = {
  remove: (dadosId) => baseAPI.delete(`${routerSolucaoExtra}?id=${dadosId}`),
  list: () => baseAPI.get(`${routerSolucaoExtra}`),
  listByMunicipio: (municipioId) =>
    baseAPI.get(
      `${routerSolucaoExtra}/obter-solucoes-extras-por-municipio-id?municipioId=${municipioId}`
    ),
  find: (dadosId) => baseAPI.get(`${routerSolucaoExtra}/${dadosId}`),
  update: (dados) => baseAPI.put(`${routerSolucaoExtra}`, dados),
  add: (dados) => baseAPI.post(`${routerSolucaoExtra}`, dados),
};

const routerMunicipioPropostaParcelasStatus =
  "api/MunicipioPropostaParcelasStatus";
export const municipioPropostaParcelasStatus = {
  list: () => baseAPI.get(`${routerMunicipioPropostaParcelasStatus}`),
};
